import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "合同履约", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更多")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "申请金额：", -1)
const _hoisted_6 = { class: "vo-ft-dag" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("审批")

import { onMounted, ref, reactive, unref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { PerformPadingApi } from "@/apis/homes/apis";
import { BillAuditDialog } from '@/views/bills/components/Index';



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { push } = useRouter()
const auditDialogRef = ref<InstanceType<typeof BillAuditDialog>>()

const state = reactive({
    loading: false,
})

const dataList = ref<Array<any>>([])

const load = {
    getPerformWaitList: async () => {
        state.loading = true
        const { data } = await PerformPadingApi({ dataTake: 5 });
        dataList.value = data || [];
        state.loading = false
    }
}

const actions = {
    /* 更多按钮 */
    more: () => {
        push({ path: '/works/contractaudit' })
    },
    /* 数据预览 */
    preview: (rowId: string) => {
        unref(auditDialogRef)?.showDialog(rowId, true);
    },
    /* 审核 */
    audits: (rowId: string) => {
        unref(auditDialogRef)?.showDialog(rowId, false);
    },
}

onMounted(() => {
    load.getPerformWaitList();
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_ListItemMeta = _resolveComponent("ListItemMeta")!
  const _component_ListItem = _resolveComponent("ListItem")!
  const _component_List = _resolveComponent("List")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            link: "",
            onClick: actions.more
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          rows: 4,
          loading: _unref(state).loading,
          animated: ""
        }, {
          default: _withCtx(() => [
            (dataList.value.length > 0)
              ? (_openBlock(), _createBlock(_component_List, {
                  key: 0,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_ListItem, null, {
                        action: _withCtx(() => [
                          _createElementVNode("li", null, [
                            _createVNode(_component_el_button, {
                              type: "warning",
                              size: "small",
                              link: "",
                              onClick: ($event: any) => (actions.preview(item.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_el_button, {
                              type: "success",
                              size: "small",
                              link: "",
                              onClick: ($event: any) => (actions.audits(item.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_ListItemMeta, {
                            title: `${item.contract_name}`
                          }, {
                            avatar: _withCtx(() => [
                              _createVNode(_component_el_avatar, { style: {"font-size":"14px"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.pay_type.slice(0, 1)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            description: _withCtx(() => [
                              _createElementVNode("span", null, "付款计划：" + _toDisplayString(item.plan_name), 1),
                              _hoisted_4,
                              _hoisted_5,
                              _createElementVNode("span", _hoisted_6, _toDisplayString(item.amount.toLocaleString('zh')), 1),
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 256))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  "image-size": 80,
                  description: "没有可履约的合同记录"
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_unref(BillAuditDialog), {
      ref_key: "auditDialogRef",
      ref: auditDialogRef,
      onSuccess: _cache[0] || (_cache[0] = ($event: any) => (load.getPerformWaitList()))
    }, null, 512)
  ], 64))
}
}

})